module.exports = __webpack_public_path__ + "media/images/flags/CW-fc4e676e3380417248a4219d67d91b91.svg";